import React from "react";

import { getStrValue } from "../../../store/utility";
import {
  FormControl,
  InputGroup,
  Col,
  Button,
  Form,
  Row
} from "react-bootstrap";
import UploadZone from "../UploadZone";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

export default class InterventionTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      interventionDate: this.setNowIfNotExists(props.request.executedAt),
      interventionResume: this.setResume(props.request.intervention),
      request: this.props.request,
      //fileFields: [{}],
      files:[]

    };
  }

  setNowIfNotExists(m) {
    return m === null ? moment() : moment(m, 'DD/MM/YYYY');
  }

  setResume(intervention) {
    return intervention === null ? null : intervention.resume;
  }

  setFiles = (files) => {
    this.setState({ files: files });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.request !== nextProps.request) {
      let { interventionDate, request,interventionResume } = this.state;
      request = nextProps.request;
      interventionDate =
        nextProps.request.executedAt === null
          ? null
          : moment(nextProps.request.executedAt, "DD/MM/YYYY");
      interventionResume = nextProps.request.response;
      this.setState({ request, interventionDate, interventionResume });
    }
  }

  //Plannification / Réponse
  interventionDateHandler = (selectedDate) => {
    this.setState({
      interventionDate: selectedDate,
    });
  };

  inputResponseChangeHandler = (event) => {
    this.setState({
      interventionResume: event.target.value,
    });
  };

  interventionRequestHandler = (event) => {
    event.preventDefault();
    const { request, interventionResume, files } = this.state;
    let { interventionDate } = this.state;

    if (null === interventionDate) {
      interventionDate = moment();
    }

    const req = {
      id: request.id,
      executedAt: interventionDate.format("DD/MM/YYYY"),
      resume: interventionResume,
      status: 1,
    };

    this.props.updIntervention(req, files);
  };

  render() {
    const { request } = this.state;
    const display = request.executedAt === null;
    //const { interventionDate } = this.state;
    return (
      <Form>
        <Row>
          <Col sm={5}>
            {display ? (
              <InputGroup>
                <InputGroup.Addon>Traitée le</InputGroup.Addon>
                  <DatePicker
                    selected={this.state.interventionDate}
                    id="interventionDate"
                    style={{ cursor: "pointer" }}
                    onChange={(event) => this.interventionDateHandler(event)}
                    locale="fr"
                    className="form-control"
                  />
                  <InputGroup.Addon>
                    <span className="fa fa-calendar" />
                  </InputGroup.Addon>
                </InputGroup>
            ) : (
                  <InputGroup>
                    <InputGroup.Addon>Traitée le</InputGroup.Addon>
                  <FormControl
                    type="text"
                    value={getStrValue(request.executedAt)}
                    className="form-control"
                    disabled
                  />
                  <InputGroup.Addon>
                    <span className="fa fa-calendar" />
                  </InputGroup.Addon>
                </InputGroup>
            )}
          </Col>
          <Col sm={7}></Col>
        </Row>
        <Row>
          <Col sm={display ? 9 : 12}>
            <textarea
              rows="8"
              className="form-control note-editor"
              disabled={request.executedAt !== null}
              value={getStrValue(this.state.interventionResume)}
              onChange={this.inputResponseChangeHandler}
            />
          </Col>
          {display ? (
          <Col sm={3}>
              <UploadZone setFiles={(values) => this.setFiles(values)} isIntervention={true} />
            </Col>) : null}
        </Row>
        {display ? (<Button
          bsClass="btn btn-block btn-primary mt-lg"
          onClick={(event) => this.interventionRequestHandler(event)}
        >
          <span className="fa fa-check" />{" "}Valider
        </Button>) : null}
        
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Request/Tab/InterventionTab.js